import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { DateTime } from 'luxon';
import { toDateTime } from '../../../utils/date-time';

@Pipe({ name: 'toDateTime' })
export class ToDateTimePipe implements PipeTransform {
    transform(value: string | DateTime): any {
        const instance = toDateTime(value);

        if (instance?.isValid) {
            return instance;
        }

        return null;
    }
}
